import { FarmlyPlace } from "@/lib/types";
import { PLACES } from "@/data/places";

/**
 * Fetches places from mock data.
 * Always returns immediately with local data.
 */
export async function fetchPlacesMock(): Promise<FarmlyPlace[]> {
  // Simulate slight async delay for consistency with Supabase path
  await new Promise((resolve) => setTimeout(resolve, 50));
  return PLACES;
}

/**
 * Fetches a single place by slug from mock data.
 */
export async function fetchPlaceBySlugMock(
  slug: string
): Promise<FarmlyPlace | null> {
  await new Promise((resolve) => setTimeout(resolve, 50));
  return PLACES.find((p) => p.slug === slug) ?? null;
}
